import { createSelector } from 'reselect';

export const makeSelectPage = (state) => state.page;

export const makeSelectReferrer = createSelector(makeSelectPage, (state) => state.referrer);

export const makeSelectIsInternalNav = createSelector(makeSelectPage, (state) => state.internalNav);

export const makeSelectNavigationHistory = createSelector(makeSelectPage, (state) => state.history);
